import { render, staticRenderFns } from "./inquiries.vue?vue&type=template&id=a7de90aa&"
import script from "./inquiries.vue?vue&type=script&lang=js&"
export * from "./inquiries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "inquiries.vue"
export default component.exports